import {useHydrated} from './useHydrated';
import {useTheme} from 'next-themes';

export const useThemeToggle = () => {
    const {theme, setTheme, systemTheme} = useTheme();
    const mounted = useHydrated();

    const isDark = mounted ? (theme === 'dark' || (theme === 'system' && systemTheme === 'dark')) : false;

    const handleThemeToggle = () => {
        setTheme(isDark ? 'light' : 'dark');
    };

    const themeIcon = isDark ? 'mdi:weather-sunny' : 'mdi:weather-night';

    return {isDark, mounted, handleThemeToggle, themeIcon};
};
